<template>
  <div class="content-container" style="height: auto">
    <div class="content-box">
      <div ref="reportTable" class="section-box outline">
        <search-comp @onSearch="attachData" @onReset="onReset">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Mã đặt phòng/nhóm/đoàn</div>
                    <div class="child-w-80">
                      <input v-model="searchParams.bookingCode" type="text" />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nguồn</div>
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        :rows="sourceOptions"
                        :columns="columnsSource"
                        index-field="id"
                        :disabled="!isAdmin"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        :selected-index-field-value="searchParams.sourceId"
                        :value="searchParams.sourceId"
                        @selectionChanged="onSelectRowSource"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.desc }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhân viên tạo đặt phòng</div>
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        :rows="saleAgentOptionsFilterActive"
                        :columns="columnsSaleAgent"
                        index-field="id"
                        :disabled="disabledDate"
                        :is-remove-btn="true"
                        :selected-index-field-value="searchParams.createUserId"
                        :value="searchParams.createUserId"
                        :dropdown-width="400"
                        @selectionChanged="onSelectRowCreateUser"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.full_name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhân viên kinh doanh</div>
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        :rows="saleAgentOptionsFilterActive"
                        :columns="columnsSaleAgent"
                        index-field="id"
                        :disabled="disabledDate"
                        :is-remove-btn="true"
                        :selected-index-field-value="searchParams.salesPersonId"
                        :value="searchParams.salesPersonId"
                        :dropdown-width="400"
                        @selectionChanged="onSelectRowSalesPerson"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.full_name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelId"
                        :disabled="disabledDate"
                        multiple
                        collapse-tags
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Công ty đại lý du lịch</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.agentId"
                        collapse-tags
                        filterable
                        clearable
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="item in agencyOptions"
                          :key="item.id"
                          :label="`(${item.code}) ${item.name}`"
                          :value="item.id"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">Từ ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRange"
                        :disabled="disabledDate"
                        style="display: block; width: 100%"
                        mode="date"
                        @input="setDateRange"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Hiển thị tài khoản không hoạt động</div>
                    <div class="child-w-80">
                      <el-switch />
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </search-comp>
        <div id="table-print" class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo nhân viên bán hàng</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div
            ref="agGridWrapper"
            v-loading="loading"
            class="grid-scroll mt-10"
            style="height: 400px"
          >
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              row-selection="false"
              :auto-size-cell="true"
              :auto-select-first-row="false"
              :context="context"
            />
          </div>
        </div>
      </div>
      <div v-if="isAdmin" v-loading="pieChartLoading" class="section-box outline">
        <search-comp @onSearch="getListPieChart" @onReset="onResetPieChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangePieChart"
                        style="display: block; width: 500px"
                        mode="date"
                        @input="changeDatePie"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div
          id="pieChartPdfWrapper"
          style="
            position: absolute;
            top: 0;
            height: 600px !important;
            width: 800px;
            left: -100000px;
          "
        >
          <vchart
            id="pieChartPdf"
            style="height: 600px"
            class="chart"
            :option="optionPieChartPdf"
            autoresize
          />
        </div>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionPieChart"
                    autoresize
                    @click="clickPieChart"
                  />
                  <!-- @click="handleClickPieChart" -->
                  <div class="button-containers-title">
                    <button
                      class="btn small primary outline download-button"
                      @click="downloadPieChart"
                    >
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-if="isAdmin" v-loading="lineChartLoading" class="section-box outline">
        <search-comp @onSearch="getListLineChart" @onReset="onResetLineChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhân viên bán hàng</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParamsLine.saleStaffIds"
                        collapse-tags
                        multiple
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="(sale, index) in searchParamsLine.showInactive
                            ? saleAgentOptions
                            : saleAgentOptionsFilterActive"
                          :key="index"
                          :value="sale.id"
                          :label="sale.full_name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangeLineChart"
                        style="display: block"
                        mode="date"
                        @input="changeDateLine"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="checkbox-container">
                    <div class="checkbox-wrap">
                      <input
                        id="line-isActive"
                        v-model="searchParamsLine.showInactive"
                        type="checkbox"
                      />
                      <label for="line-isActive"
                        >Hiển thị tài khoản không hoạt động</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionLineChart"
                    autoresize
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-if="isAdmin" v-loading="histogramChartLoading" class="section-box outline">
        <search-comp
          @onSearch="getListHistogramChart"
          @onReset="onResetHistogramChart"
        >
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhân viên bán hàng</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParamsHistogram.saleStaffIds"
                        collapse-tags
                        multiple
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="(
                            sale, index
                          ) in searchParamsHistogram.showInactive
                            ? saleAgentOptions
                            : saleAgentOptionsFilterActive"
                          :key="index"
                          :value="sale.id"
                          :label="sale.full_name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Tháng</div>
                    <div class="child-w-80">
                      <el-date-picker
                        v-model="monthYearBarChart"
                        :clearable="false"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="Vui lòng chọn tháng, năm"
                        @change="changeMonth"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-6">
                  <div class="checkbox-container">
                    <div class="checkbox-wrap">
                      <input
                        id="histogram-active"
                        v-model="searchParamsHistogram.showInactive"
                        type="checkbox"
                      />
                      <label for="histogram-active"
                        >Hiển thị tài khoản không hoạt động</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    id="HistogramChartPdf"
                    style="height: 400px"
                    class="chart"
                    :option="optionHistogramChart"
                    autoresize
                    @click="clickHistogram"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!--  -->
    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Ngày: Hiển thị ngày thuộc giai đoạn tìm kiếm, theo format:
              DDMMYYYY
            </li>
            <li>Tổng số phòng: Tổng số phòng vật lý của khách sạn</li>
            <li>Phòng bị chiếm: Tổng số phòng đã được gán cho đặt phòng</li>
            <li>Số lượng phòng sửa chữa OOO: số lượng phòng hỏng</li>
            <li>
              Phòng có thể bán: bằng tổng số phòng trừ Phòng sửa chữa trừ phòng
              bị chiếm
            </li>
            <li>
              Phòng miễn phí: Số lượng đặt phòng có tích là phòng miễn phí
            </li>
            <li>
              Doanh thu của những phòng bị chiếm là doanh thu chỉ tính tiền
              phòng của các phòng bị chiếm, tự động phân cách bằng dấu phẩy; là
              doanh thu thực (Đã trừ giảm giá)
            </li>
            <li>
              Doanh thu khi full: Doanh thu phòng của tổng số phòng trừ đi phòng
              OOO, tự động phân cách bằng dấu phẩy.
            </li>
            <li>
              Tỉ lệ doanh thu thực: Doanh thu thực của phòng bị chiếm/ Doanh thu
              khi full*100, lấy 2 chữ số sau dấu phẩy
            </li>
            <li>
              Công suất: bằng phòng bị chiếm/tổng số phòng *100, lấy 2 số sau
              dấu phẩy
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { use } from 'echarts/core'
use([BarChart, PieChart, LineChart])
import { getAccount, getAgent } from '@/api/reception/common'

import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import { getSourceApi } from '@/api/Statistics/source'
import { color } from '@/utils/color'
import { displayDate } from '@/utils/helper'
import {
  getAllSales,
  getListSaleEmployee,
  getPieChart,
  getLineChartApi,
  getHistogramChartApi,
  getListSaleEmployeeExcel
} from '@/api/report_service/salesEmployeeReport'
import { CellRenderTextLink } from '@/utils/cellRenders'
import html2pdf from 'html2pdf.js'
const getOptionPieChartDefaultPdf = () => ({
  align: 'center',
  title: {
    text: 'Tỉ lệ của từng nhân viên bán hàng'
    // left: '5%'
  },
  grid: {},
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value + '%'
  },
  legend: {
    orient: 'horizontal',
    width: '500px',
    // type: 'scroll',
    // top: 50,
    // left: '5%'
    bottom: 20
  },
  series: [
    {
      name: 'Nhân viên',
      type: 'pie',
      // right: '10%',
      top: '30px',
      left: '20%',
      width: '60%',
      height: '80%',
      avoidLabelOverlap: true,
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})
const getOptionPieChartDefault = () => ({
  title: {
    text: 'Tỉ lệ của từng nhân viên bán hàng'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value + '%'
  },
  legend: {
    orient: 'vertical',
    type: 'scroll',
    textStyle: {
      width: 300,
      overflow: 'break'
    },
    top: 50,
    left: '5%'
    // bottom: 20
  },
  series: [
    {
      name: 'Nhân viên',
      type: 'pie',
      // right: '10%',
      left: '40%',
      width: '60%',
      avoidLabelOverlap: true,
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})

const getOptionLineChartDefault = () => ({
  title: {
    text: 'Biểu đồ tăng trưởng của các nhân viên bán hàng'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    // valueFormatter: 'abc',
    enterable: true
    // triggerOn: 'click'
  },
  legend: {
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 60
  },
  xAxis: [
    {
      type: 'category',
      // axisTick: {
      //   alignWithLabel: true
      // },
      axisLine: {
        onZero: false
        // lineStyle: {
        //   color: '#5470C6'
        // }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Precipitation  ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       )
      //     }
      //   }
      // },
      // prettier-ignore
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})
const getOptionHistogramChartDefault = () => ({
  title: {
    text: 'Biểu đồ histogram doanh thu của các nhân viên bán hàng theo tháng'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    // valueFormatter: 'abc',
    enterable: true,
    showDelay: 100,
    hideDelay: 300
  },
  legend: {
    type: 'scroll',
    bottom: 0,
    height: '100px',
    borderType: 'dotted'
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: 60,
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable,
    CellRenderTextLink
  },
  data() {
    return {
      disabledDate: false,
      pieChartLoading: false,
      lineChartLoading: false,
      histogramChartLoading: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        wrapText: true,
        autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      monthYearBarChart: this.$moment().format('YYYY-MM-DD'),
      datetimeRangePieChart: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      datetimeRangeLineChart: {
        start: this.$moment().startOf('month').format('YYYY-MM-DD'),
        end: this.$moment().endOf('month').format('YYYY-MM-DD')
      },
      defaultDatetimeRangeLineChart: {
        start: this.$moment().startOf('month').format('YYYY-MM-DD'),
        end: this.$moment().endOf('month').format('YYYY-MM-DD')
      },
      searchParamsPie: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      },
      defaultSearchParamsPie: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      },
      searchParamsLine: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        saleStaffIds: null,
        showInactive: false
      },
      defaultSearchParamsLine: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        saleStaffIds: null,
        showInactive: false
      },
      searchParamsHistogram: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        saleStaffIds: null,
        showInactive: false
      },
      defaultSearchParamsHistogram: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        saleStaffIds: null,
        showInactive: false
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      loading: false,
      dialogFormVisible: false,
      hotelList: [],
      agencyOptions: [],
      searchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        createUserId: '',
        salesPersonId: '',
        sourceId: '',
        bookingCode: ''
      },
      defaultSearchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        createUserId: '',
        salesPersonId: '',
        sourceId: '',
        bookingCode: ''
      },
      sourceOptions: [],
      saleAgentOptions: [],
      columnsSaleAgent: [
        {
          headerName: 'ID Nhân viên',
          field: 'code',
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name',
          flex: 1
        }
      ],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      columns: [
        {
          headerName: 'Mã nhóm/đoàn',
          field: 'group_code',
          sortable: false,
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          cellRenderer: 'CellRenderTextLink',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.guestName'),
          field: 'traveller_nm',
          tooltipField: 'traveller_nm',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Công ty đại lý du lịch',
          field: 'agent_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 220,
          width: 260
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          tooltipField: 'room_level_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.dateOrder'),
          field: 'date_booking',
          valueGetter: params => {
            return displayDate(params.data.date_booking)
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'date_from',
          minWidth: 120,
          maxWidth: 120,
          valueGetter: params => {
            return displayDate(params.data.date_from)
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'date_to',
          valueGetter: params => {
            return displayDate(params.data.date_to)
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.expectedRevenue'),
          field: 'expected_revenue',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          minWidth: 120,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.realRevenue'),
          field: 'real_revenue',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.refund'),
          field: 'refund',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Nhân viên tạo đặt phòng',
          field: 'create_user_nm',
          valueGetter: params => this.getCreateUserName(params.data),
          minWidth: 180
        },
        {
          headerName: 'Nhân viên kinh doanh',
          field: 'sales_person_nm',
          valueGetter: params =>
            params.data?.sales_person_nm ??
            params.data?.salesPersonNm ??
            '',
          minWidth: 180
        }
      ],
      optionPieChart: getOptionPieChartDefault(),
      optionPieChartPdf: getOptionPieChartDefaultPdf(),
      optionLineChart: getOptionLineChartDefault(),
      optionHistogramChart: getOptionHistogramChartDefault(),

      rows: []
    }
  },
  computed: {
    bookingCode() {
      return this.searchParams.bookingCode
    },
    saleAgentOptionsFilterActive() {
      return this.saleAgentOptions.filter(item => item.is_active)
    },
    // Map Vuex getter ra computed property
    userInfo() {
      return this.$store.getters['userInfo/userInfo']
    },
    isAdmin() {
      return this.$store.getters['userInfo/canFilterAccountInReport']
    }
  },
  watch: {
    bookingCode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
          this.searchParams.sourceId = null
          this.searchParams.createUserId = null
          this.searchParams.salesPersonId = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    },
    'searchParamsLine.showInactive': {
      handler(val) {
        if (!val) {
          this.searchParamsLine.saleStaffIds = []
        }
      }
    },
    'searchParamsHistogram.showInactive': {
      handler(val) {
        if (!val) {
          this.searchParamsHistogram.saleStaffIds = []
        }
      }
    }
  },
  created() {
    this.getListHotel()
    this.getListSource()
    this.getListSales()
    this.getAgencyOptions()
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.attachData()
    this.getListPieChart()
    this.getListLineChart()
    this.getListHistogramChart()
    // console.log('[mounted] isAdmin:', this.isAdmin)
  },
  methods: {
    setSearchParamSourceId() {
      const matchedSource = this.sourceOptions.find(
        (item) => item.business_man_id === this.userInfo.id
      )

      if (matchedSource) {
        this.searchParams.sourceId = matchedSource.id
      } else {
        this.searchParams.sourceId = null
      }
    },
    onCellRenderTextLinkClick(data) {
      const tmpRecode = data?.data?.recode
      if (tmpRecode) {
        // this.$router.push(`/reservation/search_reservation?recode=${tmpRecode}`)
        const routeData = this.$router.resolve({
          path: '/reservation/search_reservation',
          query: {
            recode: tmpRecode
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    handleCommand(cmmd) {
      if (cmmd == 'pdf') {
        let worker = html2pdf()
        let element = document.getElementById('table-print')
        worker.from(element).toPdf().save()
      }
      if (cmmd == 'excel') {
        getListSaleEmployeeExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'sale_agent_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    changeDatePie(val) {
      this.searchParamsPie.dateFrom = val.start
      this.searchParamsPie.dateTo = val.end
    },
    changeDateLine(val) {
      this.searchParamsLine.dateFrom = val.start
      this.searchParamsLine.dateTo = val.end
    },
    changeMonth(val) {
      this.searchParamsHistogram.dateFrom = this.$moment(val, 'YYYY-MM')
        .startOf('month')
        .format('YYYY-MM-DD')
      this.searchParamsHistogram.dateTo = this.$moment(val, 'YYYY-MM')
        .endOf('month')
        .format('YYYY-MM-DD')
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListSource() {
      // console.log('[getListSource] userInfo:', this.userInfo)
      // console.log('[getListSource] isAdmin:', this.isAdmin)
      try {
        const res = await getSourceApi({ isActive: 1 })
        let list = res.data || []

        console.log('list: ', list)

        console.log('is admin: ', this.isAdmin)

        // Nếu không phải admin → lọc theo business_man_id
        if (!this.isAdmin && this.userInfo?.id) {
          list = list.filter(
            item => item.business_man_id === this.userInfo.id
          )
        }

        this.sourceOptions = list

        // Sau khi load → set giá trị mặc định
        this.setSearchParamSourceId()
        if (!this.isAdmin && this.searchParams.sourceId) {
          this.attachData()
        }
      } catch (error) {
        console.error(error)
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`message.error.${message}`)
        })
      }
    },
    async getListSales() {
      // const data = await getAllSales()
      // this.saleAgentOptions = data.data.map(item => item?.account)
      const res = await getAccount({
        userGroupNames: ['Sale-All', 'FO-All']
      })
      this.saleAgentOptions = res.data.map(item => item.account) || []
      this.$nextTick(() => {
        this.$refs.agGrid?.gridApi?.refreshCells({ force: true })
      })

      // this.sourceOptions = data.data
    },
    async getAgencyOptions() {
      await getAgent()
        .then(response => {
          this.agencyOptions = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getListSaleEmployee(this.searchParams)
        this.loading = false
        this.rows = data.data || []
      } catch {
      } finally {
        this.loading = false
      }
    },
    getCreateUserName(row = {}) {
      const createUserId = row.create_user_id ?? row.createUserId
      const account = this.saleAgentOptions.find(
        item => String(item.id) === String(createUserId)
      )

      return (
        row.create_user_nm ??
        row.createUserNm ??
        account?.full_name ??
        account?.username ??
        createUserId ??
        ''
      )
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val?.id
    },
    onSelectRowCreateUser(val) {
      this.searchParams.createUserId = val?.id
    },
    onSelectRowSalesPerson(val) {
      this.searchParams.salesPersonId = val?.id
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      if (!this.isAdmin) {
        this.setSearchParamSourceId()
      }
      this.attachData()
    },
    async getListPieChart() {
      let res = await getPieChart(this.searchParamsPie)
      var data = res.data
      const sortList = res.data.sort((a, b) => b?.revenue - a?.revenue)
      const top9List = sortList.slice(0, 9)
      const otherList = sortList.slice(9)
      const otherListDebtSum = otherList.reduce((acc, item) => {
        return item?.revenue + acc
      }, 0)
      if (otherListDebtSum > 0) {
        top9List.push({
          revenue: otherListDebtSum,
          sale_person_nm: 'Others'
        })
      }

      var total = 0
      data.map(item => {
        total = total + item.revenue
      })
      this.optionPieChart = getOptionPieChartDefault()
      this.optionPieChart.series[0].data = top9List.map(item => {
        return {
          value: ((item.revenue / total) * 100).toFixed(2),
          name: item.sale_person_nm,
          id: item.sale_person_id
        }
      })
      this.optionPieChartPdf = getOptionPieChartDefaultPdf()
      this.optionPieChartPdf.series[0].data = top9List.map(item => {
        return {
          value: ((item.revenue / total) * 100).toFixed(2),
          name: item.sale_person_nm,
          id: item.sale_person_id
        }
      })
    },
    async clickPieChart(value) {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.datetimeRange.start = this.searchParamsPie.dateFrom
      this.datetimeRange.end = this.searchParamsPie.dateTo
      this.searchParams.dateFrom = this.searchParamsPie.dateFrom
      this.searchParams.dateTo = this.searchParamsPie.dateTo
      this.searchParams.salesPersonId = value.data.id
      await this.attachData()
      this.$nextTick().then(async () => {
        await this.$refs.reportTable.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    },
    onResetLineChart() {
      this.datetimeRangeLineChart = { ...this.defaultDatetimeRangeLineChart }
      this.searchParamsLine = {
        ...this.defaultSearchParamsLine
      }
      this.getListLineChart()
    },
    onResetPieChart() {
      this.datetimeRangePieChart = { ...this.defaultDatetimeRange }
      this.searchParamsPie = {
        ...this.defaultSearchParamsPie
      }
      this.getListPieChart()
    },
    async getListLineChart() {
      this.optionLineChart = getOptionLineChartDefault()
      if (
        this.$moment(this.searchParamsLine.dateTo).diff(
          this.$moment(this.searchParamsLine.dateFrom),
          'days'
        ) < 2
      ) {
        this.$message({
          type: 'error',
          message: 'Khoảng thời gian có độ dài tối thiểu 3 ngày.'
        })
        return
      }
      let res = await getLineChartApi({
        ...this.searchParamsLine,
        isActive: !this.searchParamsLine.showInactive
      })
      let data = res.data

      for (
        var m = this.$moment(this.searchParamsLine.dateFrom);
        m.isSameOrBefore(this.$moment(this.searchParamsLine.dateTo));
        m.add(1, 'days')
      ) {
        this.optionLineChart.xAxis[0].data.push(m.format('DD-MM-YYYY'))
      }
      for (var i = 0; i < data.length; i++) {
        this.optionLineChart.series[i] = {
          name: data[i].sale_staff_nm,
          id: data[i].sale_staff_id,
          type: 'line',
          xAxisIndex: 0,
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: data[i].saleRevenueResList
        }
      }
    },
    async getListHistogramChart() {
      let res = await getHistogramChartApi({
        ...this.searchParamsHistogram,
        isActive: !this.searchParamsHistogram.showInactive
      })
      this.optionHistogramChart = getOptionHistogramChartDefault()
      let data = res.data
      for (let i = 0; i < data.length; i++) {
        this.optionHistogramChart.xAxis[0].data[i] = data[i].date

        for (var j = 0; j < data[0].sale_staff_revenue.length; j++) {
          if (
            !this.optionHistogramChart.series.some(item => {
              return item.id === data[i].sale_staff_revenue[j].sale_staff_id
            })
          ) {
            this.optionHistogramChart.series.push({
              name: data[i].sale_staff_revenue[j].sale_staff_nm,
              id: data[i].sale_staff_revenue[j].sale_staff_id,
              type: 'bar',
              stack: 'revenueSales',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: data.map(item => {
                var val = null
                item.sale_staff_revenue.map(item1 => {
                  if (
                    data[i].sale_staff_revenue[j].sale_staff_id ===
                    item1.sale_staff_id
                  ) {
                    val = item1.revenue
                  }
                })
                return val
              })
            })
          }
        }
      }
    },
    onResetHistogramChart() {
      this.searchParamsHistogram = { ...this.defaultSearchParamsHistogram }
      this.monthYearBarChart = this.$moment().format('YYYY-MM-DD')
      this.getListHistogramChart()
    },
    async clickHistogram(val) {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.datetimeRange.start = val.name
      this.datetimeRange.end = val.name
      this.searchParams.dateFrom = val.name
      this.searchParams.dateTo = val.name
      await this.attachData()
      this.$nextTick().then(async () => {
        await this.$refs.reportTable.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    },
    downloadPieChart() {
      let opt = {
        margin: 1,
        filename: 'chart_sale_agent.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
      }
      let worker = html2pdf()
      let element = document.getElementById('pieChartPdf')
      console.log(element)
      worker.set(opt).from(element).toPdf().save()
    }
  }
}
</script>

<style lang="scss" scoped>
.section-box {
  height: auto !important;
}

.checkbox-container {
  background: #fff !important;
  align-items: end;
  height: 100%;
}
</style>
